//登录相关接口
import request from '@/utils/request'

//登录
export const login = (data) => {
    return request({
        url: '/api/user/userLogin',
        method: 'post',
        data
    })
}

//修改登录密码
export const updatePassword = (data) => {
    return request({
        url: '/api/common/updatePassword',
        method: 'post',
        data
    })
}

//修改支付密码
export const setPayPassword = (data) => {
    return request({
        url: '/api/common/setPayPassword',
        method: 'post',
        data
    })
}

//发送验证码
export const send = (data) => {
    return request({
        url: "/api/sendMsg/send",
        method: 'post',
        data
    })
}